<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "MailToButton" });
import { Button } from "../index.js";
export let to = "";
export let cc = "";
export let color = "primary";
export let css = "";
export let subject = "";
export let body = "";
export let label = "Send Email";
const createMailToLink = () => {
    let mailToLink = `mailto:${encodeURIComponent(to)}`;
    const PARAMS = [];
    if (cc.length > 0) {
        PARAMS.push(`cc=${encodeURIComponent(cc)}`);
    }
    if (subject.length > 0) {
        PARAMS.push(`subject=${encodeURIComponent(subject)}`);
    }
    if (body.length > 0) {
        PARAMS.push(`body=${encodeURIComponent(body)}`);
    }
    if (PARAMS.length > 0) {
        mailToLink += `?${PARAMS.join("&")}`;
    }
    return mailToLink;
};
const SEND_EMAIL = createMailToLink();
</script>

<Button
    { color }
    { css }
    { label }
    url = { SEND_EMAIL }
/>